import { ui } from "../../../../interfaces/interfaces";
import { apiGoCardless } from "@services/CCMAccess/apiAccess";
import { logger } from "@services/workers/helpers";
import { RightioGoCardlessAPIWrapperModelsDtoBankAccountRequestDto, RightioGoCardlessAPIWrapperModelsDtoCustomerDto, RightioGoCardlessAPIWrapperModelsDtoCustomerRequestDto } from "../../../apis/ccm/model";
import { serviceAgreement } from "..";

const getBankAccountData = (
  goCardlessCustomer: RightioGoCardlessAPIWrapperModelsDtoCustomerDto,
  customerId: number,
  accountNumber: string,
  sortCode: string
): RightioGoCardlessAPIWrapperModelsDtoBankAccountRequestDto => ({
  accountHolderName: `${ui.CarePlanBillingContactFirstName} ${ui.CarePlanBillingContactLastName}`,
  accountNumber,
  sortCode,
  metadata: {
    ServiceAgreementCustomerId: `${customerId}`,
  },
  links: {
    customer: goCardlessCustomer.id,
  },
});

const updateGoCardlessBankAccountId = (bankAccountId: string) => {
  serviceAgreement.serviceAgreementPaymentDetails.goCardlessBankAccountId = bankAccountId;
};

export const createGoCardlessBankAccount = async (customerId: number, customerRequest: RightioGoCardlessAPIWrapperModelsDtoCustomerRequestDto) => {

  logger.debug("createGoCardlessBankAccount", "GoCardless->CreateCustomer");
  const goCardlessCustomer = await apiGoCardless.postCustomer(customerRequest);

  if (!goCardlessCustomer || !goCardlessCustomer.id) return;

  const bankAccountRequest = getBankAccountData(
    goCardlessCustomer,
    customerId,
    ui.CarePlanPaymentBankDetailsAccountNumber,
    ui.CarePlanPaymentBankDetailsSortCode
  );

  logger.debug("createGoCardlessBankAccount", "GoCardless->CreateBankAccount");
  const goCardlessBankAccount = await apiGoCardless.postBankAccount(bankAccountRequest);

  if (goCardlessBankAccount && goCardlessBankAccount.id) {
    updateGoCardlessBankAccountId(goCardlessBankAccount.id);
  }

  return goCardlessBankAccount;
};
